import { ADD_IMAGES, DELETE_IMAGES, GET_IMAGES } from "../actions/Image.action";

const initialState = {
    addImages: '',
    getImages: '',
    deleteImages:''
}

const imageReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_IMAGES:
            return { ...state, addImages: action.payload };
        case GET_IMAGES:
            return { ...state, getImages: action.payload };
        case DELETE_IMAGES:
            return { ...state, deleteImages: action.payload };
        default:
            return state;
    }
}

export default imageReducer;